import React, { useState, useEffect, useRef } from "react";
export default function EventTimer({
  startTime
}) {
  const [timer, setTimer] = useState("00:00:00:00"); // The state for our timer
  const timerID = useRef(null);
  const getTimeRemaining = e => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor(total / 1000 % 60);
    const minutes = Math.floor(total / 1000 / 60 % 60);
    const hours = Math.floor(total / (1000 * 60 * 60) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
  };
  const startTimer = e => {
    let {
      total,
      days,
      hours,
      minutes,
      seconds
    } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the begining of the variable

      setTimer((days > 9 ? days : "0" + days) + ":" + (hours > 9 ? hours : "0" + hours) + ":" + (minutes > 9 ? minutes : "0" + minutes) + ":" + (seconds > 9 ? seconds : "0" + seconds));
    } else if (timerID.current) {
      clearInterval(timerID.current);
    }
  };
  const getDeadTime = end => {
    let deadline = new Date(Number(end));
    // This is where you need to adjust if
    // you entend to add more time
    // deadline.setSeconds(deadline.getSeconds());
    return deadline;
  };
  useEffect(() => {
    if (typeof window !== "undefined") {
      const clearTimer = e => {
        if (timerID.current) clearInterval(timerID.current);
        const id = setInterval(() => {
          startTimer(e);
        }, 1000);
        timerID.current = id;
      };
      clearTimer(getDeadTime(Number(startTime)));
    }
    return () => {
      if (timerID.current) clearInterval(timerID.current);
    };

    // eslint-disable-next-line
  }, [timerID]);
  return <span data-sentry-component="EventTimer" data-sentry-source-file="EventTimer.jsx">{timer}</span>;
}